export default "__VITE_ASSET__CRq3NGHN__"